// ADU / Tabarnapp: redondear % del badge (ej. -33.33333333% → -33%)
(function () {
  const SELECTOR = '.ProductVariant--DiscountValue';

  function formatDiscountText(text) {
    const match = String(text).trim().match(/^(-?\d+(?:\.\d+)?)\s*%$/);
    if (!match) return null;

    const raw = match[1];
    if (!raw.includes('.')) return null;

    const rounded = Math.round(Number(raw));
    if (!Number.isFinite(rounded)) return null;

    return `${rounded}%`;
  }

  function fixDiscountBadges(root = document) {
    const candidates = [];

    if (root instanceof HTMLElement && root.matches?.(SELECTOR)) {
      candidates.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SELECTOR).forEach((el) => candidates.push(el));
    }

    candidates.forEach((el) => {
      const next = formatDiscountText(el.textContent);
      if (next && el.textContent.trim() !== next) {
        el.textContent = next;
      }
    });
  }

  function init() {
    fixDiscountBadges();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            if (
              node.matches?.(SELECTOR) ||
              node.querySelector?.(SELECTOR) ||
              node.matches?.('.MainTabarnappUIContainer') ||
              node.querySelector?.('.MainTabarnappUIContainer')
            ) {
              fixDiscountBadges(node);
            }
          });
        }

        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          if (parent?.matches?.(SELECTOR)) {
            fixDiscountBadges(parent);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ADU / Tabarnapp: cerrar una sola vez al cargar; luego no intervenir
(function () {
  const ROOT_SELECTOR = '.MainTabarnappUIContainer';
  const CHEVRON_SELECTOR = '.chevron-minimize';

  let done = false;
  let observer = null;

  function tryCollapse() {
    if (done) return;

    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const expanded = root.querySelector(
      '.BottomBar-quest-container-expanded-completedQuests, [class*="BottomBar-quest-container-expanded"], .BottomBarExpandedTabs'
    );
    const chevron = root.querySelector(CHEVRON_SELECTOR);

    if (!expanded || !chevron) return;

    done = true;
    if (observer) observer.disconnect();

    // Cierre nativo de la app (una sola vez)
    chevron.click();
  }

  function init() {
    tryCollapse();

    observer = new MutationObserver(() => {
      tryCollapse();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Seguridad: dejar de observar aunque no encuentre chevron
    window.setTimeout(() => {
      done = true;
      if (observer) observer.disconnect();
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();